export enum Theme {
  fly = 'fly',
  drive = 'drive',
  multiFly = 'multi-fly',
  multiDrive = 'multi-drive',
  solo = 'solo',
  totm = 'totm',
  incontrol = 'in-control',
  bucketList = 'bucket-list',
  escapeTour = 'escape-tour',
  broke = 'broke',
  train = 'train',
  zonvoordeel = 'lente-in-je-bol',
  newplaces = 'new-places',
  summerHoliday = 'summer-holiday',
  lastMinute = 'last-minute',
  foodLoversDrive = 'food-lovers-drive',
  foodLoversFly = 'food-lovers-fly',
  themeOfTheMonth = 'theme-of-the-month',
}

export enum ThemeTypes {
  fly = 'fly',
  road = 'road',
  train = 'train',
}

export const flyThemes: Theme[] = [
  Theme.fly,
  Theme.multiFly,
  Theme.incontrol,
  Theme.bucketList,
  Theme.escapeTour,
  Theme.zonvoordeel,
  Theme.newplaces,
  Theme.summerHoliday,
  Theme.lastMinute,
  Theme.broke,
  Theme.foodLoversFly,
  Theme.themeOfTheMonth,
]

export const driveThemes: Theme[] = [
  Theme.drive,
  Theme.multiDrive,
  Theme.train,
  Theme.foodLoversDrive,
]

// Themes whose extras step shows DriveOptions (incl. pets). The order payload
// must send nr_pets for exactly these (#215).
export const driveExtrasThemes: Theme[] = [
  Theme.drive,
  Theme.multiDrive,
  Theme.foodLoversDrive,
]

// nr_pets for price/booking requests: only themes that offer pets send them,
// and only when the trip has a pets price, the same condition that shows the
// pet picker (DriveOptions.tsx). Without a price the backend's pets lookup
// fails, and the hidden picker leaves the customer no way to remove the dog.
export function getRequestNrPets(
  theme: Theme,
  numberOfPets: number,
  petsPrice: number | undefined,
): number {
  return driveExtrasThemes.includes(theme) && !!petsPrice ? numberOfPets : 0
}

// Content key + code fallback for the trip type in the drive summary (#215).
export function getDriveSummaryContent(
  theme: Theme,
): { contentKey: string; fallback: string } {
  switch (theme) {
    case Theme.train:
      return { contentKey: 'traintrip-summary', fallback: 'city break' }
    case Theme.foodLoversDrive:
      return {
        contentKey: 'food-lovers-roadtrip-summary',
        fallback: 'Food Lovers roadtrip',
      }
    default:
      return { contentKey: 'roadtrip-summary', fallback: 'city break' }
  }
}

export function getThemeAPIName(theme: Theme) {
  switch (theme) {
    case Theme.multiFly:
      return 'multi-city'
    case Theme.multiDrive:
      return 'drive'
    case Theme.solo:
      return 'solo-together'
    default:
      return theme.toString()
  }
}

// Theme whose cities the fly "exclude cities" list offers. Multi City is priced
// against an unknown destination (no cities of its own), so like Food Lovers it
// offers the regular fly cities (#176).
export function getExcludeCitiesThemeAPIName(theme: Theme): string {
  switch (theme) {
    case Theme.multiFly:
    case Theme.foodLoversFly:
      return Theme.fly
    default:
      return getThemeAPIName(theme)
  }
}

export function getThemeId(theme: Theme) {
  switch (theme) {
    case Theme.fly:
    default:
      return 50
    case Theme.drive:
      return 20
    case Theme.multiFly:
      return 1
    case Theme.multiDrive:
      return 20
    case Theme.solo:
      return 18
    case Theme.totm:
      return 38
    case Theme.incontrol:
      return 52
    case Theme.broke:
      return 53
    case Theme.zonvoordeel:
      return 55
    case Theme.train:
      return 61
    case Theme.bucketList:
      return 63
    case Theme.escapeTour:
      return 64
    case Theme.foodLoversDrive:
      return 65
    case Theme.themeOfTheMonth:
      return 66
  }
}
